/* @flow */

import React from 'react';
import { canDownloadEntities } from 'containers/decorators';
import DownloadDropdown from 'components/DownloadDropdown';
import { spinnable } from 'components/UIKit/decorators';
import Button from 'components/UIKit/Button/ButtonTemplate';
import DownloadIcon from 'components/icons/DownloadIcon';
import { Spinner } from 'components/UIKit/Spinner';

export type DynamicEntityDownloadContainerType = {
  setIsSpinning: () => {},
  isSpinning: boolean,
  downloadSingleBiospecimen: () => {},
  marginOffset: any,
  children: any,
  customDataTestID?: string
}

function DynamicEntityDownloadContainer({
  setIsSpinning,
  isSpinning,
  downloadSingleBiospecimen,
  marginOffset,
  children,
  customDataTestID,
}: DynamicEntityDownloadContainerType): React.Element {
  return (
    <DownloadDropdown
      setIsSpinning={setIsSpinning}
      marginOffset={marginOffset}
      download={async format => await downloadSingleBiospecimen(format)}
      formats={['tsv', 'json']}
      >
      <Button
        customDataTestID={customDataTestID}
        disabled={isSpinning}
        PrefixComponent={isSpinning
          ? <Spinner style={{ height: '1rem', width: '1rem', marginRight: '2px' }} />
          : <DownloadIcon />}
        >
        { children }
      </Button>
    </DownloadDropdown>
  );
}

export default canDownloadEntities(spinnable(DynamicEntityDownloadContainer));
